export default {
      id: "shipment-scan-code-usage",
      viewBox: "0 0 33 33",
      url: __webpack_public_path__ + "img/icons.svg#shipment-scan-code",
      toString: function () {
        return this.url;
      }
    }